import React from 'react';

/**
 * Open Government Licence v3.0 attribution for DVSA-sourced data.
 * Required wherever DVSA enforcement-sanctions content is displayed or redistributed.
 */
export const OGLAttribution = ({ className = '' }) => (
  <div
    className={`text-xs text-muted-foreground leading-relaxed ${className}`}
    data-testid="ogl-attribution"
  >
    <p>
      This application contains public sector information licensed under the{' '}
      <a
        href="https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/"
        target="_blank"
        rel="noopener noreferrer"
        className="underline hover:text-foreground"
      >
        Open Government Licence v3.0
      </a>
      .
    </p>
    <p>Source: Driver and Vehicle Standards Agency (DVSA).</p>
    <p>This service is not affiliated with or endorsed by the DVSA.</p>
  </div>
);
